export default {

    costableType: state => state.costableType,
    costableId: state => state.costableId,
    isCostablePageLoading: state => state.isCostablePageLoading,
    isCostableTableLoading: state => state.isCostableTableLoading,
    costable: state => state.costable,
    groups: state => state.costable.cost_groups,
    // returns true if there are any cost groups that are not 'Other Costs' (since 'Other Costs' doesn't have an `id`)
    hasCostGroups: state => state.costable.cost_groups.some(group => group.id),
    subtotals: state => state.costable.subtotals,
    totals: state => state.costable.totals,
    totalsPerGuest: state => state.costable.totals_per_guest,

    costCount: state => state.costable.cost_groups.map(group => group.costs.length).reduce((total, count) => total + count, 0),
    selectedCosts: state => state.costable.cost_groups.reduce((acc, group) => [
        ...acc,
        ...group.costs.filter(cost => cost.selected),
    ], []),
    selectedCostIds: (state, getters) => getters.selectedCosts.map(cost => cost.id),
    selectCostCount: (state, getters) => getters.selectedCostIds.length,

    isDurationEnabled: state => state.costable.settings.is_duration_enabled,
    isCostBgColourEnabled: state => state.costable.settings.is_cost_bg_colour_enabled,
    unitCostColumnColour: state => state.costable.settings.unit_cost_column_colour,
    unitPriceColumnColour: state => state.costable.settings.unit_price_column_colour,
    isCostQuantityEnabled: state => state.costable.settings.is_cost_quantity_enabled,
    isPriceUnitEnabled: state => state.costable.settings.is_price_unit_enabled,

    shouldOpenPdfsInNewTab: state => state.costable.settings.should_open_pdfs_in_new_tab,
    areTabsEnabled: state => state.costable.settings.are_tabs_enabled,
    canApproveCosts: state => state.costable.settings.can_approve_costs,
    tabs: state => state.costable.tabs,
    tabId: state => state.tabId,

    hasReportedInformation: state => state.costableType === 'event',
    hasCommission: state => parseFloat(state.costable.totals.commission_due) !== 0,
    hasFee: state => parseFloat(state.costable.totals.fee) !== 0,
    hasCurrency: state => state.costable.has_currency,
    hasCostsSummary: state => state.costableType === 'event' || state.costableType === 'quote',
    hasResourceTypeSummary: state => state.costableType === 'event' && state.costable.resource_types.length > 0,
    hasCurrencies: () => true,
    hasAcceptedQuote: state => state.costableType === 'event',
    canHaveContingency: state => state.costableType === 'event' || state.costableType === 'quote',
    canHaveServiceCharge: state => state.costableType === 'event' || state.costableType === 'quote',
    isQuote: state => state.costableType === 'quote',

    hasContingency: state => state.costable.contingency.amount_cost > 0 || state.costable.contingency.amount_price > 0,
    hasEventManagementFee: (state, getters) => getters.hasCostsSummary && getters.costsSummary.event_management_fee > 0,
    hasServiceCharge: (state, getters) => getters.costable.service_charge_amount > 0,

    reportedInformation: state => state.costable.reported_information,
    currencies: state => state.costable.currencies,
    costsSummary: state => state.costable.costs_summary,
    resourceTypeSummary: state => state.costable.resource_types,
    acceptedQuote: state => state.costable.accepted_quote,

    showTabColumn(state) {
        return state.costable.tabs.length > 0 && !state.tabId;
    },

    showTaxRateColumn: state => state.costable.settings.show_tax_rate_column,
    showNominalCodeColumn: state => state.costable.settings.show_nominal_code_column,

    settings(state) {
        return state.settings;
    },

    isEditable: state => state.costable.is_editable,

    hiddenColumns: state => state.hiddenColumns,

    columns(state, getters) {
        return [
            ...getters.leftColumns,
            ...getters.middleColumns,
            ...getters.rightColumns,
            ...getters.totalRows,
        ];
    },
    leftColumns() {
        return [
            {
                name: 'drag',
            },
            {
                name: 'select',
            },
        ];
    },
    middleColumns(state, getters) {
        return [
            {
                name: 'taxRate',
                display: getters.showTaxRateColumn,
                heading: 'cost.tax_rate',
            },
            {
                name: 'tab',
                display: getters.showTabColumn,
                heading: 'cost.tab',
            },
            {
                name: 'type',
                heading: 'cost.type',
            },
            {
                name: 'nominalCode',
                display: getters.showNominalCodeColumn,
                heading: getters.showNominalCodeColumn ? 'cost.nominal_code' : null,
            },
            {
                name: 'description',
                heading: 'cost.description',
            },
            {
                name: 'supplier',
                heading: 'cost.supplier',
            },
            {
                name: 'quantity',
                class: 'text-right no-wrap',
                heading: 'cost.quantity',
            },
            {
                name: 'duration',
                class: 'text-right no-wrap',
                display: getters.isDurationEnabled,
                heading: 'cost.duration',
            },
            {
                name: 'unitCost',
                class: ['text-right'],
                heading: 'cost.unit_cost',
                style: { 'background-color': getters.isCostBgColourEnabled ? `${getters.unitCostColumnColour}!important` : '' },

            },
            {
                name: 'currencyCost',
                display: getters.hasCurrency,
                class: ['text-right'],
                heading: 'cost.currency_cost',
            },
            {
                name: 'unitPrice',
                class: ['text-right no-wrap'],
                heading: 'cost.unit_price',
                style: { 'background-color': getters.isCostBgColourEnabled ? `${getters.unitPriceColumnColour}!important` : '' },

            },
            {
                name: 'currencyPrice',
                display: getters.hasCurrency,
                class: ['text-right'],
                heading: 'cost.currency_price',
            },
        ];
    },
    rightColumns(state, getters) {
        return [
            {
                name: 'totalCost',
                class: ['text-right no-wrap'],
                heading: 'cost.total_cost',
                style: { 'background-color': getters.isCostBgColourEnabled ? `${getters.unitCostColumnColour}!important` : '' },

            },
            {
                name: 'totalPrice',
                class: ['text-right no-wrap'],
                heading: 'cost.total_price',
                style: { 'background-color': getters.isCostBgColourEnabled ? `${getters.unitPriceColumnColour}!important` : '' },

            },
            {
                name: 'markup',
                class: 'text-right col-cost-markup',
                heading: 'cost.markup',
            },
            {
                name: 'margin',
                class: 'text-right',
                heading: 'cost.margin',
            },
            {
                name: 'fee',
                class: 'text-right',
                display: getters.hasFee,
                heading: 'cost.fee_short',
            },
            {
                name: 'commission',
                class: 'text-right',
                display: getters.hasCommission,
                heading: 'cost.commission',
            },
            {
                name: 'commissionDue',
                class: 'text-right',
                display: getters.hasCommission,
                heading: 'cost.commission_due',
            },
            {
                name: 'totalProfit',
                class: 'text-right',
                display: getters.hasCommission,
                heading: 'cost.total_profit',
            },
            {
                name: 'discount',
                class: 'text-right',
                heading: 'cost.discount',
            },
            {
                name: 'icons',
                class: 'no-wrap',
            },
            {
                name: 'user',
                heading: 'cost.user',
            },
            {
                name: 'status',
                display: !getters.settings.hide_cost_statuses,
                heading: 'cost.status',
            },
            {
                name: 'secondaryStatus',
                display: !getters.settings.hide_cost_statuses
                    && getters.settings.show_secondary_cost_status,
                heading: 'cost.secondary_status',
            },
            {
                name: 'transactionType',
                display: getters.settings.show_transaction_type,
                heading: 'cost.transaction_type',
            },
            {
                name: 'reconciled',
            },
            {
                name: 'actions',
                class: 'text-right',
            },
        ];
    },
    totalRows() {
        return [
            {
                name: 'totalsPerGuest',
                heading: 'Per Guest Totals',
            },
            {
                name: 'event_management_fee',
                heading: 'Event management fee',
            },
        ];
    },
    progress: state => state.progress,
    progressIntervalId: state => state.progressIntervalId,
};
